import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {StudentService} from '../shared/services/student.service';
import {AuthenticationService} from '../shared/services/authentication.service';
import { faSpinner} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-transfer-rijr',
    templateUrl: './transfer-rijr.component.html',
    styleUrls: ['./transfer-rijr.component.scss'],
    standalone: false
})
export class TransferRijrComponent implements OnInit {

  public faSpinner = faSpinner;

  public isSubmitted = false;
  public isProcessing = false;


  formGroup = new UntypedFormGroup({
    rijrStudentProfileId: new UntypedFormControl('', [Validators.required]),
    nawData: new UntypedFormControl(true),
    interests: new UntypedFormControl(true),
    matchTest: new UntypedFormControl(true),
    latestDNA: new UntypedFormControl(true),
  });

  constructor(
    public activatedRoute: ActivatedRoute,
    public studentService: StudentService,
    public authService: AuthenticationService
  ) {


  }

  ngOnInit(): void
  {

    this.activatedRoute.paramMap.subscribe( (paramMap) => {

      const id = paramMap.get('id');

      this.formGroup.setValue({
        rijrStudentProfileId : id,
        nawData : true,
        interests : true,
        matchTest : true,
        latestDNA : true,
      });

    });

  }

  SignUp() {
    this.authService.SignUp();
  }

  Login(){

    this.authService.Login();

  }

  onSubmit()
  {


    if (!this.formGroup.valid) {
      return;
    }

    this.isProcessing = true;

    this.studentService.apiTransferRijrStudentProfile(this.formGroup.value).subscribe( (response) => {

      this.isSubmitted = true;
      this.isProcessing = false;

    }, (error) => {

      this.isProcessing = false;

    });

  }

}
